<ng-http-loader [backdrop]="true" [backgroundColor]="'#ff0000'" [backdropBackgroundColor]="'#ffffff'" [opacity]="0.3"
  [spinner]="spinkit.skThreeBounce">
</ng-http-loader>
<div style="overflow-x: hidden;background: #fcfcfc;height: 100%;">
  <div *ngIf="restoConditions == '1'">
    <div class="container d-flex justify-content-between" style="height: 100vh; margin-top: 0px; padding: 0px;">
      <div>
        <div class="back-main-div" (click)="goBackToMenu()">
          <img src="../../../../assets/img/backMenu.svg" alt="">
          <div>Back to food menu</div>
        </div>
        <div class="aggri-main-div">
          <div class="aggri-sub-div">
            <img src="../../../../assets/img/Foodbud_name_in_grey.svg" alt="">
            <div class="aggri-text-div">
              For restaurant recommendation download foodbud app
            </div>
            <div class="download-div">
              <img src="../../../../assets/img/app-store-download.png" alt="" srcset="" (click)="openAppStore()">
              <img src="../../../../assets/img/play-store-download.png" alt="" srcset="" (click)="openPlayStore()">
            </div>
          </div>
        </div>
      </div>
      <!-- <div *ngIf="showAllResto" style="padding-top: 13px;">
        <img src="assets/img/backMenu.svg" alt="" (click)="gotoResto()" style="cursor: pointer;">
      </div>
      <div style="width: 80%">
        <mat-accordion>
          <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false"
            (click)="openLocationMap()">
            <mat-expansion-panel-header>
              <mat-panel-description>
                <div class="userLocation" *ngIf="userCurrentLocation">{{userCurrentLocations}}</div>
                <div class="userLocation" *ngIf="!userCurrentLocation">Fetching...</div>
              </mat-panel-description>
            </mat-expansion-panel-header>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
      <div style="padding-top: 13px;" (click)="goToSearchPage()">
        <img src="../../../assets/img/SearchIcon.svg" alt="" style="cursor: pointer;">
      </div> -->
    </div>



    <!-- <div class="container resto-text-pad">
      <div class=" d-flex justify-content-between">
        <div class="">
          <p class="restotext">Restaurants near you </p>
        </div>
        <div class="" *ngIf="!showAllResto">
          <p class="view-all-text" (click)="showAllRestos()">View All</p>
        </div>
      </div>
    </div>



    <div style="width: 380px;margin:0 auto;padding: 10px;" *ngIf="!showAllResto">
      <div style="overflow-x: scroll;">
        <div class="">
          <div class="scrollable-resto-div">
            <div *ngFor="let alldata of allrestaurant | slice:0:5" style="padding:0px 0px 10px 10px">
              <div class="scrollable-resto"
                (click)="onLink(alldata.restaurant_id,alldata.table_id,alldata.visitorOrigin)">
                <img src="{{alldata.featured_image}}" alt="resto-img" class="restoImg" style="width: 100%;">
              </div>
              <div class="details-div">
                <div class="tworestodistance" *ngIf="alldata.distance">{{alldata.distance}}</div>
                <div class="tworestodistances" *ngIf="!alldata.distance">0 Km</div>
                <div class="tworestoRatings"><span><img src="assets/img/star1.svg" alt=""></span><span>4.8</span>
                </div>
                <div class="tworestoNames">{{alldata.restaurant_name}}</div>
                <div class="tworestoAdress">{{alldata.restaurant_address}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container" *ngIf="!showAllResto" >
      <div style="display: flex; justify-content: space-between;">
        <p class="Categories-heading">Categories</p>
        <div class="cat-filter-mainDiv" (appOutsideClick) = outsideClick($event)> 
          <div class="cat-filter-subDiv" (click)="showCatFilter()">Filter <img src="../../../../assets/img/drop-down.svg" alt="" srcset="" id="cat-filter-arrowImg"> </div>
          <div class="cat-filter-dropDown" *ngIf="filterToggele" >
            <p *ngFor="let item of categoryType" class="cat-filter-dropdown-pTag">{{item}} <input type="checkbox" (change)="filterSelectFunc(item,$event.target)" [checked]="catFilterPreCheck(item)" /> </p>
          </div>
        </div>
      </div>
      <div class="selected-cat-filter-mainDiv" *ngIf="selectedFilter.length>0">
        <div *ngFor="let item of selectedFilter" class="selected-cat-filter-subDiv">
          {{item}}
          <img src="../../../../assets/img/filterCrossIcon.svg" (click)="filterCrossFunc(item)" >
        </div>
      </div>

      <div class="row">
        <div *ngFor="let items of categoryArray" class="cat-div">
          <div class="category-checkbox-div" style="position: relative;">
            <input type="checkbox" #{{items.category_id}} value="{{items.category_id}}" (change)="catCheckbokFunc($event, 'cat'+items.category_id)">
            <img id="{{'cat'+items.category_id}}" src="../../../../assets/img/tickMark.svg" alt=""  class="checkboxTickImg" >
            <label for=""><img src="{{items.image}}" alt="">
              <p class="cat-cuisine-text">{{items.category_name}}</p>
            </label>
          </div>
        </div>

      </div>
      <div *ngIf="showMoreCondition && !(selectedFilter.length>0)" class="main-div-showMore">
        <div *ngIf="showMoreFalg" (click)="showMoreFunc()" class="div-showMore">
          <span class="showMore-text">more</span>
          <span class="showMore-img ">
            <img src="../../../../assets/img/Icon-ionic-ios-arrow-down.svg" alt="">
          </span>
        </div>
        <div *ngIf="!showMoreFalg && !(selectedFilter.length>0)" (click)="showLessFunc()" class="div-showMore">
          <span class="showMore-text">less</span>
          <span class=" showMore-img">
            <img src="../../../../assets/img/Icon-ionic-ios-arrow-up.svg" alt="">
          </span>
        </div>

      </div>

    </div>


    <div>
      <div class="container" *ngIf="!showAllResto" style="padding-bottom: 15px;">
        <div style="display: flex; justify-content:space-between;">
          <p class="Categories-heading">Cuisines</p>
        </div>
      </div>
     
      <div *ngIf="!cuisineAllFlag && !showAllResto" class="container ">
        <div class="cuisineAll">
          <div *ngFor="let items of cuisineArray" class="cuisineOneContainer">
            <div>
              <div class="category-checkbox-div">
                <input type="checkbox" value="{{items.cuisine_id}}" (change)="cuisineCheckbokFunc($event, 'cuisine'+items.cuisine_id)">
                <img id="{{'cuisine'+items.cuisine_id}}" src="../../../../assets/img/tickMark.svg" alt=""  class="checkboxTickImg" >
                <label for=""><img src="{{items.image}}" alt="">
                  <p class="cat-cuisine-text">{{items.cuisine_name}}</p>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="showMoreCatCondition" class="main-div-showMore">
          <div *ngIf="showMoreCatFalg" (click)="showMoreCatFunc()" class="div-showMore">
            <span class="showMore-text">more</span>
            <span class="showMore-img ">
              <img src="../../../../assets/img/Icon-ionic-ios-arrow-down.svg" alt="">
            </span>
          </div>
          <div *ngIf="!showMoreCatFalg" (click)="showLessCatFunc()" class="div-showMore">
            <span class="showMore-text">less</span>
            <span class=" showMore-img">
              <img src="../../../../assets/img/Icon-ionic-ios-arrow-up.svg" alt="">
            </span>
          </div>

        </div>


      </div>

    </div>
    <div class="multiShowResto-btn" *ngIf="(conditionCatFilter || conditionCusineFilter)&& !showAllResto">
      <button class="filter-btn " (click)="getFilterResto()">Show Restaurants
      </button>
    </div>

    <div *ngIf="showAllResto">
      <div class="container" style="margin-top: -7px;">
        <div *ngFor="let alldata of allrestaurant| filter:searchText ;let i =index" class="cardmaindiv">
          <mat-card (click)="onLink(alldata.restaurant_id,alldata.table_id,alldata.visitorOrigin)"
            style="cursor: pointer;">
            <div>
              <div>
                <img src="{{alldata.featured_image}}" alt="resto-img" class="allRestoImages">
              </div>
              <div class="resto-distance">
                {{alldata.distance}}
              </div>
            </div>
            <div class="col-12 d-flex justify-content-between">
              <div class="col-10">
                <div class="resto-name">
                  {{alldata.restaurant_name}}
                </div>
              </div>
              <div class="col-2">
                <div class="resto-rating">
                  <span class="star"><img src="assets/img/star1.svg" alt=""></span> <span>4.6</span>
                </div>
              </div>
            </div>

            <div class="col-12 d-flex justify-content-between" style="padding-bottom: 10px;">
              <div class="col-10">
                <div class="resto-address">
                  {{alldata.restaurant_address}}
                </div>
              </div>
            </div>
          </mat-card>
        </div>
      </div>
    </div> -->

  </div>


  <!-- <div *ngIf="restoConditions == '2'">
    <div class="container" style="padding-top: 13px;">
      <div class="d-flex">
        <div class="col-4">
          <img src="assets/img/backMenu.svg" alt="" (click)="gotoRestos()" style="cursor: pointer;">
        </div>
        <div class="col-6">
          <p class="location">Search</p>
        </div>
      </div>
    </div>
    <div class="blankLine">
      &nbsp;
    </div>

    <div class="container ">
      <div class="searchbar">
        <span style="padding-left: 10px;"><img src="assets/img/SearchIcon.svg" alt=""></span>
        <input type="text" placeholder="Search restaurants" class="searchInpBox" [(ngModel)]="searchText"
          (input)="checkFiletered(searchText)">
      </div>
    </div>

    <div class="container" style="margin-top: 7px;" *ngIf="showFilteredResto">
      <div *ngFor="let alldata of allrestaurant| filter:searchText ;let i =index" class="cardmaindiv">
        <mat-card (click)="onLink(alldata.restaurant_id,alldata.table_id,alldata.visitorOrigin)"
          style="cursor: pointer;">
          <div>
            <div>
              <img src="{{alldata.featured_image}}" alt="resto-img" class="allRestoImages">
            </div>
            <div class="resto-distance">
              {{alldata.distance}}
            </div>
          </div>
          <div class="col-12 d-flex justify-content-between">
            <div class="col-10">
              <div class="resto-name">
                {{alldata.restaurant_name}}
              </div>
            </div>
            <div class="col-2">
              <div class="resto-rating">
                <span class="star"><img src="assets/img/star1.svg" alt=""></span> <span>4.6</span>
              </div>
            </div>
          </div>

          <div class="col-12 d-flex justify-content-between" style="padding-bottom: 10px;">
            <div class="col-10">
              <div class="resto-address">
                {{alldata.restaurant_address}}
              </div>
            </div>
          </div>
        </mat-card>
      </div>
    </div>
  </div>


  <div *ngIf="restoConditions == '3'">
    <div class="container">
      <div id="map">
        <agm-map [zoom]='19' [latitude]="lat" [longitude]="lng">
          <agm-marker [latitude]="lat" [longitude]="lng" [markerDraggable]="true" (dragEnd)="markerDragEnd($event)">
          </agm-marker>
        </agm-map>
      </div>
    </div>
  </div> -->
</div>